
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.333.333H2c-.733 0-1.333.6-1.333 1.334v10.666c0 .734.6 1.334 1.333 1.334h8c.733 0 1.333-.6 1.333-1.334v-8l-4-4zm2.667 12H2V1.667h4.667V5H10v7.333zm-1.333-6v4.734l-1.4-1.4L5.4 11.533 3.533 9.667 5.4 7.8 3.933 6.333h4.734z","fill":"#0094D9"}})])
          )
        }
      }
    